import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';


// import {
// 	statisticsAction,
// 	statisticsCloseAction
// } from '../../../actions/settingsAction.js';


import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';

import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min.js';
import { useParams } from "react-router-dom";
const HrLeaveDetails = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	const defaultChecked = false;

	const [selectedItems, setSelectedItems] = useState([]);
	const [isChecked, setIsChecked] = useState({ defaultChecked });


	const [checkbox, setCheckbox] = useState([]);

	const history = useHistory();
	const [data, setData] = useState([]);
	// const [leavedetaildata, setLeaveDetailData] = useState([]);
	


	const { search } = useLocation();
	const searchparams = new URLSearchParams(search);
	const param = searchparams.get("id");
	//const handleChange = (e) => setCheckbox(e.target.checked);

	// alert(param);

    const [leavedet, setLeaveDetail] = useState({
            status: "",
            remarks: "",
            leave_type_id:"",
            leave_id:"",
			emp_id:"",
            diff_days:"",
			available_leave:"",
            leave_available:"",
            sick_leave_available:"",
	compoff_days: ""  // ← added
           
        })
	

        const handelInput = (event) => {
            event.preventDefault();
            const { name, value } = event.target;
            console.log(name, value)
            setLeaveDetail({ ...leavedet, [name]: value });
        }









	const handleEditLeaveStatus = (e) => {

		e.preventDefault();
		//console.log('selected options: '+ roledata.join(", "));
		// e.preventDefault();
		//console.log(param);


		

		
			const emp_id=leavedet.employee_id
            let available_leave_det;

			if(leavedet.leave_type_id==1)
			{
				available_leave_det=leavedet.sick_leave_available;
			}
			else if((leavedet.leave_type_id==2) || (leavedet.leave_type_id==9))
			{
				available_leave_det=leavedet.leave_available;
			}
		

		
		






		axios.post(API_BASE_URL + '/hr_update_leave_status', { status: leavedet.status,remarks:leavedet.remarks, leave_id: param,leave_type_id:leavedet.leave_type_id,emp_id:emp_id,from_date:leavedet.from_date,diff_days:leavedet.diff_days,available_leave:available_leave_det, compoff_days: leavedet.compoff_days }, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {

			// console.log(response.data);

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				setTimeout(() => {
					return history.push("Hr-leave");
				}, 3000);

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {

			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});







	 };


	useEffect(() => {
		axios.get(API_BASE_URL + '/hr_leave_detail/' + param, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})

		    //  .then(res1 =>console.log(res1))
			.then(res1 => setLeaveDetail(res1.data.leave_detail))
			.catch(err => console.log(err));
	}, [])




	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />


						</div>
					</div>


					<div className="section-body mt-3">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-4 col-lg-4">
                                <div className="card">
                                    <div className="card-header">
                                        <h5 className="card-title">Leave Detail</h5>
                                    </div>
                                    <div className="card-body">
                                      
                                        <div className="table-responsive">
                                            <table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
                                                    <tbody>
                                                        <tr>
                                                        <th>Employee</th>
                                                        <td>{leavedet.full_name}</td>
                                                        </tr>
                                                        <tr>
                                                        <th>Leave Type</th>
                                                        <td>{leavedet.type}</td>
                                                        </tr>
                                                        <tr>
                                                        <th>Applied On</th>
                                                        <td>{leavedet.applied_on}</td>
                                                        </tr>
                                                        <tr>
                                                        <th>Start Date</th>
                                                        <td>{leavedet.from_date}</td>
                                                        </tr>
                                                        <tr>
                                                        <th>End Date</th>
                                                        <td>{leavedet.to_date}</td>
                                                        </tr>

														<tr>
                                                        <th>Reason</th>
                                                        <td>{leavedet.reason}</td>
                                                        </tr>
                                        
                                        
                                                    </tbody>
                                            </table>
                                        </div>



                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-8">
                                <form className="card" onSubmit={handleEditLeaveStatus}>
                                    <div className="card-body">
                                        <h3 className="card-title">Update Status</h3>
                                        <div className="row">
                                         
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">Status</label>
                                                    <select className="form-control show-tick" name="status" value={leavedet.status} onChange={handelInput}>
                                                    <option value="1" >Pending</option>
                                                    <option value="2" >Approved</option>
                                                    <option value="3" >Rejected</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group mb-0">
                                                    <label className="form-label">Remarks</label>
                                                    <textarea rows={5} className="form-control" id="textarea" name="remarks" value={leavedet.remarks}  onChange={handelInput} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    
                      

                                    <div className="card-footer text-left">

                                    <input type="hidden" name="leave_type_id" value={leavedet.leave_type_id} />
                                    <input type="hidden" name="emp_id" value={leavedet.employee_id} />
                                    <input type="hidden" name="diff_days" value={leavedet.diff_days} />
                                    <input type="hidden" name="from_date" value={leavedet.from_date} />
                                   <input type="hidden" name="compoff_days" value={leavedet.compoff_days} />

                                    {leavedet.leave_type_id==1 &&  (
                                    <input type="hidden" name="available_leave" value={leavedet.sick_leave_available} />
                                )}

                                    {(leavedet.leave_type_id==2)||(leavedet.leave_type_id==9) && (
                                    <input type="text" name="available_leave" value={leavedet.leave_available} />
                                )}

                                        <button type="submit" className="btn btn-primary">Save</button>
                                    </div>

                                    {/* {leavedet.status==1 && (

                                   
                                    )} */}
                                </form>
                           
                            </div>




                        </div>
                    </div>

                    </div>




				</div>
			</div>









		</>
	);
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(HrLeaveDetails);